<template>
  <div class="portal">
    <v-row>
      <v-col cols="12" md="3" class="px-2">
        <NavigationComponent />
      </v-col>
      <v-col cols="12" md="9">
        <h2 class="mb-3">خلاصه عملکرد</h2>
        <v-card class="text-center pa-4">
          <v-card-title>گزارش کلی</v-card-title>
          <div v-if="!loading" class="pa-3">
            جناب آقای / سرکار خانم
            <strong>{{ portal.user.firstname }}</strong>
            <strong> {{ portal.user.lastname }}</strong>
            رابط محترم پورتال
            <strong>{{ portal.name }}</strong>
            ؛ عمکرد پورتال شما به صورت خلاصه به شرح زیر می باشد:
            <v-simple-table dense class="pt-3">
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>میزان فروش</td>
                    <td>
                      <number-component
                        :number="sumOfPayments ? sumOfPayments[0].total : 0"
                        unit="تومان"
                      ></number-component>
                    </td>
                  </tr>
                  <tr>
                    <td>سهم پورتال</td>
                    <td>
                      <span v-if="sumOfPayments">
                        ({{ portal.percentage }}%)
                      </span>
                      <number-component
                        :number="sumOfPayments ? sumOfPayments[0].share : 0"
                        unit="تومان"
                      ></number-component>
                    </td>
                  </tr>
                  <tr>
                    <td>تعداد فروش</td>
                    <td>
                      <number-component
                        :number="sumOfPayments ? sumOfPayments[0].count : 0"
                        unit="عدد"
                      ></number-component>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import NavigationComponent from "./_Navigation.vue";
export default {
  name: "portal-component",
  components: {
    NavigationComponent
  },
  data() {
    return {
      loading: true,
      portal: null,
      sumOfPayments: null
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      this.$api.get("/Payments/Portal/Sum/").then((res) => {
        this.portal = res.data.portal;
        if (res.data.sumOfPayments.length > 0) {
          this.sumOfPayments = res.data.sumOfPayments;
        }
        this.loading = false;
      });
    }
  }
};
</script>
